export const EnglishInformalWithEmoji = [
  {
    sentence:
      "I finally completed the {COURSE_TITLE} course on FaraDars and got my certificate! 🎉",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Happy to say I’ve finished the {COURSE_TITLE} course on FaraDars and received my certificate! 🏅",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Just wrapped up the {COURSE_TITLE} course on FaraDars and got my certificate! 💪",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Thrilled to have completed the {COURSE_TITLE} course on FaraDars and received my certificate! 🎓",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Excited to share that I completed the {COURSE_TITLE} course on FaraDars and got my certificate! 🌟",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "After finishing the {COURSE_TITLE} course on FaraDars, I’ve got my certificate in hand! 🥳",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Proud to have completed the {COURSE_TITLE} course on FaraDars and earned my certificate! 📜",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Done with the {COURSE_TITLE} course on FaraDars and got my certificate! 🚀",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Finished the {COURSE_TITLE} course on FaraDars and received my certificate! 🏆",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Happy to have completed the {COURSE_TITLE} course on FaraDars and earned my certificate! 🌠",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Wrapped up the {COURSE_TITLE} course on FaraDars and got my certificate! 🎖️",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "I finished the {COURSE_TITLE} course on FaraDars and now have my certificate! 🎉",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Proud to say I completed the {COURSE_TITLE} course on FaraDars and earned my certificate! 🥇",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Excited to have completed the {COURSE_TITLE} course on FaraDars and received my certificate! 🌟",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Wrapped up the {COURSE_TITLE} course on FaraDars and earned my certificate! 💫",
    tone: "informal",
    course_title: true,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "I finally completed a course on FaraDars and got my certificate! 🎉",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Happy to say I’ve finished a course on FaraDars and received my certificate! 🏅",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "Just wrapped up a course on FaraDars and got my certificate! 💪",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Thrilled to have completed a course on FaraDars and received my certificate! 🎓",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Excited to share that I completed a course on FaraDars and got my certificate! 🌟",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "After finishing a course on FaraDars, I’ve got my certificate in hand! 🥳",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Proud to have completed a course on FaraDars and earned my certificate! 📜",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "Done with a course on FaraDars and got my certificate! 🚀",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "Finished a course on FaraDars and received my certificate! 🏆",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Happy to have completed a course on FaraDars and earned my certificate! 🌠",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "Wrapped up a course on FaraDars and got my certificate! 🎖️",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "I finished a course on FaraDars and now have my certificate! 🎉",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Proud to say I completed a course on FaraDars and earned my certificate! 🥇",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence:
      "Excited to have completed a course on FaraDars and received my certificate! 🌟",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
  {
    sentence: "Wrapped up a course on FaraDars and earned my certificate! 💫",
    tone: "informal",
    course_title: false,
    lang: "en",
    using_emoji: true,
  },
];
